export enum ApiRoutes {
  // events
  EventData = "/event-data",
  EventsByCustomer = "/event-data/by-customer",
  EventsByModel = "/event-data/by-model",
  EventsByFacility = "/event-data/by-facility",
  EventsByModelAndFacility = "/event-data/by-model-and-facility",
  GetEventDetails = "/event-data/by-id",
  UpdateEventDetails = "/event-data/update-event-details",
  GetRecentEvents = "/event-data/get-recent-events",

  // recordings
  RecordingsByEvent = "/recordings/by-event",
  RecordingsByFacility = "/recordings/by-facility",
  RecordingsByModel = "/recordings/by-model",
  RecordingsByModelAndFacility = "/recordings/by-model-and-facility",

  // feedback
  UpdateEventFeedback = "/event-data/update-feedback",
}
